"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetch_1 = require("../utils/fetch");
exports.default = {
    getSchools: function (params) {
        return fetch_1.default("/schools", {
            method: "GET",
        }, params);
    },
    getFaculties: function (params) {
        return fetch_1.default("/faculties", {
            method: "GET",
        }, params);
    },
    getUserSchools: function () {
        return fetch_1.default("/user-schools", { method: "GET" });
    },
    addUserSchool: function (data) {
        var url = "/add-user-school";
        var body = JSON.stringify(data);
        return fetch_1.default(url, {
            method: "POST",
            body: body,
        });
    },
    removeUserSchool: function (data) {
        var url = "/remove-user-school";
        var body = JSON.stringify(data);
        return fetch_1.default(url, {
            method: "DELETE",
            body: body,
        });
    },
};
//# sourceMappingURL=schools.js.map